export function AdjustPopover(myElementRefVariableName: string, scrollableContentVariableName: string): ClassDecorator {
    return function (constructor: any) {
        const ionViewDidEnter = constructor.prototype.ionViewDidEnter;

        constructor.prototype.ionViewDidEnter = function () {
            setTimeout(() => {
                // still one tick to early even in ionViewDidEnter, so use timeout

                const me = this[myElementRefVariableName].nativeElement;
                const parent = this.renderer.parentNode(me);
                // const scrollContent = this[scrollableContentVariableName].nativeElement;
                // console.log('AdjustPopover', scrollableContentVariableName, this[scrollableContentVariableName], scrollContent);
                const overflow = parent.scrollHeight - parent.clientHeight;
                if (0 < overflow) { // partly off-screen
                    const newTop = parent.getBoundingClientRect().top - overflow;
                    if (newTop < 0) { // too big for screen
                        const fullHeight = this.platform.height();
                        this.renderer.setStyle(parent, 'top', 0);
                        this.renderer.setStyle(parent, 'bottom', 0);
                        // next lines were needed in ionic4-beta-13 or -14
                        // const childrenNotScrollContentHeight = me.scrollHeight - scrollContent.getBoundingClientRect().height;
                        // this.renderer.setStyle(scrollContent, 'height', (fullHeight - childrenNotScrollContentHeight) + 'px');
                        this.renderer.setStyle(me, 'height', fullHeight + 'px');
                    } else {
                        this.renderer.setStyle(parent, 'top', newTop + 'px');
                        this.renderer.setStyle(parent, 'bottom', 'auto');
                    }
                } else {
                    this.renderer.setStyle(parent, 'bottom', 'auto');
                }
            }, 50);
            if (ionViewDidEnter) ionViewDidEnter.apply(this);
        };
    };
}
